"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("./dashboard.scss");
var organization_edit_form_1 = require("../../components/form/organization-edit-form");
var organization_structure_1 = require("../../components/organization/organization-structure");
var OrganizationSettings = /** @class */ (function (_super) {
    __extends(OrganizationSettings, _super);
    function OrganizationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationSettings.prototype.tabs = function (orgIdAsInt) {
        return [
            {
                heading: "General",
                content: (React.createElement("div", { className: "u-xs-padMd u-sm-spaceTopLg u-flexExpandSides" }, !orgIdAsInt ? null : (React.createElement(organization_edit_form_1.default, { employeeView: false, selectedOrganizationId: orgIdAsInt }))))
            },
            {
                heading: "Org Structure",
                content: (React.createElement("div", { className: "u-xs-padMd u-sm-spaceTopLg u-flexExpandSides" },
                    React.createElement(organization_structure_1.default, { orgId: orgIdAsInt })))
            },
        ];
    };
    OrganizationSettings.prototype.render = function () {
        var orgId = this.props.match.params.orgId;
        var orgIdAsInt = +orgId;
        return (React.createElement("div", { id: "settings", className: "container" },
            React.createElement("div", { className: "page-content u-xs-padMd u-sm-spaceTopLg u-flexExpandSides" },
                React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                    React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                        React.createElement("h2", null, "Organization Settings"))),
                React.createElement(teamsnap_ui_1.Tabs, { tabs: this.tabs(orgIdAsInt) }))));
    };
    return OrganizationSettings;
}(React.Component));
exports.default = OrganizationSettings;
//# sourceMappingURL=organization-settings.js.map